import { Alert, Row } from "antd";
import { ReactNode, useMemo } from "react";

type ErrorsContainerProps = {
  data: string[];
};

export const ErrorsContainer = ({ data }: ErrorsContainerProps) => {
  const title: ReactNode = useMemo(() => {
    return (
      <>
        {data.map((item: string, i: number) => (
          <Row className="d-block" key={i}>
            {item}
          </Row>
        ))}
      </>
    );
  }, [data]);

  return (
    <Alert
      type="error"
      message={title}
      showIcon
      className="d-flex align-start task-errors"
    />
  );
};
